export default "__VITE_ASSET__Dn8uCtSf__"